export default "__VITE_ASSET__B8ywNA0U__"